import React from 'react';
import { useField } from 'formik';
import RowBuilder, {
  RowBuilderProps,
} from 'components/Common/FormBuilder/RowBuilder';

export default function RowMobileNumberBuilder({
  field: { optInSmsName, ...field },
  styles,
}: RowBuilderProps): JSX.Element {
  const [{ value: smsCheckedValue }] = useField(optInSmsName);

  return (
    <RowBuilder
      styles={styles}
      field={{ ...field, required: smsCheckedValue === 'O' }}
    />
  );
}
